import type { Call, CallerMatchKind, Voicemail } from '../types/sales';

/** "2 min 05 s", "45 s", or null when the call has no length yet. */
export function callLength(sec: number | null | undefined): string | null {
  if (sec == null) return null;
  if (sec < 60) return `${sec} s`;
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m} min ${String(s).padStart(2, '0')} s`;
}

export const MATCH_KIND_LABEL: Record<CallerMatchKind, string> = {
  contact: 'Customer contact',
  customer: 'Customer',
  customer_site: 'Customer site',
  supplier: 'Supplier',
  staff: 'Staff',
  worker: 'Worker',
  labour_provider: 'Labour provider',
};

/** The other party's number: who called in, or who was called out. */
export function otherNumber(call: Call): string | null {
  return call.direction === 'outbound' ? call.dialled_number : call.caller_number;
}

export const STATUS_LABEL: Record<Call['status'], string> = {
  ringing: 'Ringing',
  answered: 'On the call',
  missed: 'Missed',
  ended: 'Answered',
};

/** What a ringing call is called on its card: who it is, else the name the network gave, else the number. */
export function callerTitle(call: Call): string {
  return call.matched_name || call.caller_name || call.caller_number || 'Unknown number';
}

const OVERDUE_MS = 24 * 3600 * 1000;

/** A voicemail not followed up a day after it was left. */
export function isOverdue(vm: Voicemail, now = Date.now()): boolean {
  return vm.status !== 'followed_up' && now - new Date(vm.received_at).getTime() > OVERDUE_MS;
}
